export const expirationTime = 86400000 // Day in ms

export const CHATBOT_ID = 'chatbot-id'

export const CONVERSATIONAL_CHATBOT_OPEN_EVENT = 'mountChatWidget'

export const LOAD_CHATBOT_SCRIPT_ID = 'load-iris-script'
